export const HTTP_CONFLICT = 409;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_GONE = 410;
